import createSuperAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/super-agent-factory";
import createAIAgentKBTrackingService from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/agent-knowledge-base/services/tracking/factory";
import type { track as TrackFunction } from "pro-features/components/WithTrack/src/WithTrack";

import createLeadGeneratorTrackingService from "../../sub-modules/lead-generator/services/tracking/factory";

import createAIEmailAgentTrackingService from "./email-factory";
import createAIMeetingAgentTrackingService from "./meeting-factory";

const createAIAgentTrackingService = (track: TrackFunction) => {
    return {
        meeting: createAIMeetingAgentTrackingService(track),
        leadGenerator: createLeadGeneratorTrackingService(track),
        email: createAIEmailAgentTrackingService(track),
        kb: createAIAgentKBTrackingService(track),
        superAgent: createSuperAgentTrackingService(track),
    };
};

export default createAIAgentTrackingService;
